import api from './api';
import type { Event, EventsResponse, FilterOptions, PaginationInfo } from '@/types/event';
import { userService } from './userService';
// import { tokenManager } from '@/services/authApi';
// import { useUser } from '@/contexts/UserContext';

// const { user } = useUser();
// console.log(user);
// const isAuthenticated = !!user?.isAuthenticated;
const isAuthenticated = userService.isAuthenticated();
// console.log(isAuthenticated);

export const eventApi = {
  // Get events with filters and pagination
  getEvents: async (params: {
    page?: number;
    search?: string;
    date_filter?: string;
    category?: string;
    location?: string;
    per_page?: number;
    eventId?: string;
    scheduleId?: string|null;
  }): Promise<EventsResponse> => {
    // const prefix = isAuthenticated ? 'v1' : 'public';
    const prefix = 'public';
    // console.log(prefix);
    const response = await api.get(`/${prefix}/events`, { params });
    return response.data as any;
  },

  // Get filter options
  getFilterOptions: async (): Promise<{ filters: FilterOptions }> => {
    const response = await api.get('/public/events/filter-options');
    return response.data as any;
  },

  // Get single event details
  getEvent: async (id: string | number): Promise<{ event: Event }> => {
    const response = await api.get(`/events/${id}`);
    return response.data as any;
  },

  // Get single event details
  getTags: async (): Promise<{ tags: any }> => {
    const response = await api.get(`public/events/tags`);
    return response.data as any;
  },

  // Register for event
  registerForEvent: async (scheduleId: string | number, data: {
    phone_number?: string;
    notes?: string;
  }): Promise<{ message: string; data?: string; status?: string|number; error?: string|null }> => {
    const response = await api.post(`/v1/events/schedules/${scheduleId}/register`, data); 
    
    // console.log(response);

    const responseData = ((response?.data as any)?.data as any)?.data ?? (response?.data as any)?.data ?? response?.data;  
    const responseMessage = ((response?.data as any)?.data as any)?.message ?? (response?.data as any)?.message ?? '';  
    const responseStatus = ((response?.data as any)?.data as any)?.status ?? (response?.data as any)?.status ?? response?.status;  
    const responseError = ((response?.data as any)?.data as any)?.error ?? (response?.data as any)?.error ??  null;  
    
    return { message: responseMessage, data: responseData, status: responseStatus, error: responseError }
    ;
  },

  // Check event registration status
  getRegistrationStatus: async (scheduleId: string | number): Promise<{
    is_registered: boolean;
    registration_date?: string;
    status?: string;
  }> => {
    const response = await api.get(`/v1/events/schedules/${scheduleId}/check-registration`);
    // console.log('getRegistrationStatus:', response);
    return ((response?.data as any)?.data as any)?.data ?? (response?.data as any)?.data ?? response?.data;
    // return { is_registered: true };
  },

  // Get user's event registrations
  getUserRegistrations: async (): Promise<{
    registrations: Array<{
      id: string;
      event_id: string;
      event_title: string;
      event_date: string;
      status: string;
      registered_at: string;
    }>;
  }> => {
    const response = await api.get('/v1/events/my/registrations');
    // console.log('getUserRegistrations:', response);

    const responseData = ((response?.data as any)?.data as any)?.data ?? (response?.data as any)?.data ?? response?.data;
  
    if(!responseData.length) {
      return {
        registrations: []
      }
    }

    // Map the response data to the expected format
    const registrations = responseData.map((registration: any) => ({
      id: registration.id.toString(),
      event_id: (registration?.event_schedule?.fk_event_id || registration?.event_schedule?.event?.id).toString(),
      event_title: registration.event_schedule.event.title,
      event_date: registration.event_schedule.schedule_at,
      status: registration.status_code,
      registered_at: registration.created_at
    }));

    return {
      registrations
    };
  },

  // Cancel registration
  cancelRegistration: async (registrationId: string): Promise<{ message: string }> => {
    const response = await api.delete(`/event-registrations/${registrationId}`);
    return response.data as any;
  }, 

  // Get user's event quotas
  getMyQuotas: async (): Promise<{    
    quotas: Array<[]>;
    grouped_quotas: Array<[]>;
    summary: {
      career_coaching: {
          total_quota: number;
          total_remaining: number;
      },
      professional_network_building: {
          total_quota: number;
          total_remaining: number;
      }
    };
  }> => {
    if(isAuthenticated) {          
      const response = await api.get('/v1/events/my/quotas');
      // console.log(response?.data);
      return response?.data as any;
    } else {
      return {
        quotas: [],
        grouped_quotas: [],
        summary: {
          career_coaching: {
              total_quota: 0,
              total_remaining: 0,
          },
          professional_network_building: {
              total_quota: 0,
              total_remaining: 0,
          }
        }
      };
    }
  }, 
};